import React from 'react';
import { OKButton } from 'commonsComponents/OKButton';

const CreditCardAnchorButton = ({ text, handleClick }) => (
    <a className="profile-anchor-link" href="#profileForm">
        <OKButton onClick={handleClick}>{text}</OKButton>
    </a>
);

export default CreditCardAnchorButton;
